import React, { useState } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import AcceptIcon from '../../assets/icons/accept-icon';
import CancelIcon from '../../assets/icons/cancel-icon';

const UniversalConfirmAction = ({
  id,
  clickCallBack,
  doubleCheck,
  disabled,
  displayElement,
  buttonName,
  style,
}: {
  id: string;
  clickCallBack: Function;
  doubleCheck?: boolean;
  disabled?: boolean | false;
  displayElement?: any;
  buttonName?: string;
  style?: any;
}) => {
  const [doubleChecking, setDoubleChecking] = useState<boolean>(false);

  const handleAddToQue = () => {
    if (doubleCheck) setDoubleChecking(true);
    else clickCallBack();
  };
  const handleConfirmation = () => {
    clickCallBack();
    setDoubleChecking(false);
  };
  let displayComponent = (<><Button
    id={id}
    onClick={handleAddToQue}
    variant="outlined"
    size="small"
    color="primary"
    style={style}
    disabled={disabled}
  >
    {buttonName || "Add to Queue"}
  </Button></>);
  if (displayElement != null) {
    displayComponent = displayElement;
  }

  return (
    <Box display="block" px={2} pt={2} pb={2}>
      {!doubleChecking ? (
        displayComponent
      ) : (
        <Box display="flex" alignItems="center">
          <Typography>Are you sure?</Typography>
          <IconButton id={`${id}-confirm`} onClick={() => handleConfirmation()} size="large">
            <AcceptIcon />
          </IconButton>
          <IconButton
            id={`${id}-deny`}
            onClick={() => setDoubleChecking(false)}
            aria-label="edit"
            size="large"
          >
            <CancelIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
export default UniversalConfirmAction;
